import React, { FC } from 'react'
import styles from './StreamControl.module.scss'
import Button from '@bt-react/components/Button'
import { StreamControlProps } from './types'
import { IconType } from '@bt-react/components/Icon'

const StreamControl: FC<StreamControlProps> = ({ onStreamControlBtnClick }) =>
  <div data-bdd='stream-control'
    className={styles['stream-control']}>
    <Button
      dataBdd='stream-control-button'
      className={styles['stream-control-button']}
      text='End stream'
      onClick={onStreamControlBtnClick}
    />
  </div>

export default StreamControl